import React from "react";
import Container from "@material-ui/core/Container";
import LandingPageHeader from "../../LandingPage/views/LandingPageHeader";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";

//CSS import
import "./About.css";

const OurTeam = () => {
  return (
    <React.Fragment>
      <LandingPageHeader NavButton="ourteam" />
      {/* Flex Container */}
      <div className="flex-container">
        {/* Home Section */}

        <section about="home" style={{ padding: "30px" }}>
          <h1 className="heading">Our Team</h1>
          <Container>
            <p className="paragraph">
                The pace of Today Pharmacy business is swiftly changing than before
                and in order to keep up to date, real-time data should be at your
                fingertips, you need seamless applications that can Sync your
                Current Workflow and provide the experience your Team expects.
                However, traditional IT architectures are simply not keeping pace to
                meet today's challenges of time and scale. Aims Rx is a Event-driven
                architecture (EDA) enables your business Managing applications to be
                more agile, scalable, and responsive to your needs so that you can
                Streamline you current Activities and focus on areas where your
                presence is much needed.
            </p>
            <p className="paragraph">
                One of the most crucial factors in any Retail Sector is inventory.
                Pharmacies are striving to keep Enough Inventory on shelf. In
                Today's World Pharmacy Owner are facing critical Pressure on the
                reimbursement and DIR Fees, they Desire as little cash as possible
                tied up in Their Inventory. None of the Pharmacy Owner's like their
                Capital held captive in inventory. Saving the capital can be
                utilized for the business growth.
            </p>
            <p className="paragraph">
                Everyday Pharmacies are seeing new Compliances and New Challenges,
                running An Independent pharmacy became a Hornet's nest. Pharmacies
                are seeing decline in reimbursements and incline on DIR Fees and
                expenses. It is getting difficult to get focused on day to day
                operations Most of us were focusing on the Compliance and how to
                generate the revenue on the other side leaving the holes open.
                AimsRx is powerful tools to fill the holes and let you focus on the
                other side of the aisle
            </p>
            <p className="paragraph">
                As you look to gain productivity and agility AIMS can handle your
                Day to day operations and break you down from individual driven
                system to system Driven Individuals
            </p>
            <p className="paragraph">
                Data is the key Asset of any organization if you can view in a right
                perspective you can make right decisions AIMS RX is a revolutionary
                tool which changes the way Organizations Analyze and manage their
                data.
            </p>
            <p className="paragraph">
                Most of the small business rely on minimum wage employees As the
                Govt. is moving forward on increasing the minimum wages it is
                impacting the business owners to thrive on the payroll. Decreasing
                the man power will not increase the productivity of an organization
                but utilizing and managing the manpower in a right way can improve
                the productivity and revenue Aims Rx helps you to get the most of
                your payroll.
            </p>
          </Container>
        </section>
        {/* Process 1 Section */}
      </div>
      <LandingPageFooter />
    </React.Fragment>
  );
};

export default OurTeam;
